var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 
  'app--menu-open': (! _vm.activeViewports.some(({name}) => name == 'desktop') || this.menu.hideOnDesktop) && this.menu.isOpen
},attrs:{"id":"app"}},[_c('div',{staticClass:"nav-mask",on:{"click":function($event){return _vm.closeMenu()}}}),_c('transition',{attrs:{"name":"main-fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }